import Step16 from './Step16-compose';

export default Step16;
